
export interface ScanWidgetState {
    caseSearchModel: string
    requestSearchModel: string
}

export interface ScanWidgetDashboardItem {
    subType: string
    disabled: boolean
    icon: string
    label: string
}

export interface ScanWidgetPaginatorInfo {
    size: number
    id: string
    identifierType: string
}

export interface ScanWidgetPatientResourceService {
    paginator(info: ScanWidgetPaginatorInfo): any
}

export const initialScanWidgetState =
    (): ScanWidgetState => ({
        caseSearchModel: '',
        requestSearchModel: ''
    })
